import script from "./DonutChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DonutChart.vue?vue&type=script&setup=true&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=713c2937&lang=css"

const __exports__ = script;

export default __exports__